import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["link"];

  connect() {
    this.updateLinks();
  }

  updateLinks() {
    const selectedCurrency = localStorage.getItem("selectedCurrency");
    if (selectedCurrency) {
      this.linkTargets.forEach((link) => {
        const url = new URL(link.href);
        url.searchParams.set("selected_currency", selectedCurrency);
        link.href = url.toString();
      });
    }
  }
}